<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="goToCart()">
      <v-col>
        <div class="section-abstract-title">Règlements et avoirs</div>
        <div class="section-abstract-display">Vos factures à régler</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;"></div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionGroupementFactureExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Regroupement des factures</div>
        <div class="section-abstract-display">{{regroupementLabel}}</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionReglementListExtend', 'etablissement', true)">
      <v-col>
        <div class="section-abstract-title">Prochaine facture</div>
        <div class="section-abstract-display">Générer vos factures</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;"></div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementCartAbstract from '@/generated/sections/SectionEtablissementCartAbstract.vue';
  import { Sections, Modules } from "@/generated/classes/AppSchema.ts";
  import Etablissement, { EtablissementModeFactures } from "@/generated/classes/Etablissement";
  import Route from "@/generated/classes/Route.ts";
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import { ETABLISSEMENT_MODE_FACTURE_ITEMS } from '@/extend/controls/etablissement/EtablissementModeFacture';

  export default defineComponent({
    extends: SectionEtablissementCartAbstract,
    components: {},
    props: {
      route: {
        type: Route,
      },
    },
    created() {
      if (this.route && this.route.section == Sections.ETABLISSEMENT_CART_ABSTRACT) {
        this.goToCart();
      }
    },
    computed: {
      regroupementLabel(): string {
        const item = ETABLISSEMENT_MODE_FACTURE_ITEMS.find(i => i.key === this.etablissement.modeFacture);
        return item?.title || '';
      }
    },
    methods: {
      goToCart(): void {
        CiRouter.setRouteChangedSelector(null);
        CiRouter.setRoute(null);
        this.$router.push({
          name: Modules.CART.toLowerCase(),
          query: { etablissementId: String(this.etablissement.id) },
        });
      },
      headerTitle(): string {
        return "Prochaine facture pour " + this.etablissement.alias;
      },
    }
  })
</script>
